<template>
	<v-card
		class="consent-chart-card"
		elevation="2"
		rounded="lg"
		:style="cardStyle"
	>
		<div class="consent-chart-card__header">
			<v-icon
				v-if="icon"
				class="consent-chart-card__icon"
			>
				{{ icon }}
			</v-icon>
			<span class="consent-chart-card__title">
				{{ title }}
			</span>
			<v-spacer />
			<div
				v-if="$slots['header-actions']"
				class="consent-chart-card__actions"
			>
				<slot name="header-actions" />
			</div>
		</div>
		<div class="consent-chart-card__body">
			<slot />
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'consent-chart-card',
	props: {
		icon: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: ''
		},
		height: {
			type: [Number, String],
			default: 360
		}
	},
	computed: {
		cardStyle () {
			const h = typeof this.height === 'number' ? `${this.height}px` : this.height
			return { height: h }
		}
	}
}
</script>

<style scoped>
.consent-chart-card {
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.consent-chart-card__header {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	padding: 12px 16px;
}

.consent-chart-card__icon {
	margin-right: 8px;
	color: var(--v-primary-base);
	font-size: 1.25rem;
}

.consent-chart-card__title {
	font-size: 1rem;
	font-weight: 500;
	color: var(--global-foreground, inherit);
}

.consent-chart-card__actions {
	display: flex;
	align-items: center;
	gap: 4px;
	margin-left: auto;
}

/* Ensure action buttons don't affect header height */
.consent-chart-card__actions :deep(.v-btn) {
	min-width: 0;
}

.consent-chart-card__actions :deep(.v-btn--icon) {
	width: 28px;
	height: 28px;
}

.consent-chart-card__body {
	flex: 1 1 auto;
	min-height: 0;
	padding: 12px 16px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

/* Ensure any chart inside fills the body */
.consent-chart-card__body :deep(.bar-chart-container),
.consent-chart-card__body :deep(.line-chart-container),
.consent-chart-card__body :deep(.pie-chart-container) {
	flex: 1 1 auto;
	min-height: 0;
	height: 100%;
}

/* Canvas respects container */
.consent-chart-card__body :deep(canvas) {
	max-width: 100%;
	max-height: 100%;
}
</style>
